/**
 * 题目表单
 * @description 题目新增、编辑
 * @author mll
 * @date 2020-1-22
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Cascader } from 'antd'
import { formValidator, numberValidator, authValidator, outputClassValidator, options, _tableFormProps } from "./config";
import LimitCount from "./limitCount";
import { actionOption } from "./../ruleConfigure/config"
import { component_tool, framework_tool } from '@/tool'
import $$ from 'cmn-utils';
let { WizAvatarUpload, ossFileUtils } = framework_tool
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizLocationSelect,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup
import { WizTableForm, WizAuthority } from '@/containers/common';


/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class RuleForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bizType: undefined,
            propsInit: false,
            bizChange: false,
            date: new Date().getTime()
        }
    }

    componentDidMount() {
        let { data, form } = this.props;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps['data']) {
            if (nextProps['data']['bizType'] || nextProps['data']['bizType'] == 0) {
                if (!nextState['propsInit']) {
                    nextState['bizType'] = nextProps['data']['bizType']
                    nextState['propsInit'] = true
                }
            }
        }

        return true
    }


    /**
     * 数据校验方法
     */
    targetScopeValidator = (rule, value, callback) => {
        if (!value) {
            callback('请选择适用范围');
            return;
        }
        if (!value['orgIds'] || (value['orgIds'] && !value['orgIds'].length)) {
            callback('请选择品牌');
            return;
        }
        if (!value['positionCategoryIds'] || (value['positionCategoryIds'] && !value['positionCategoryIds'].length)) {
            callback('请选择岗位分类');
            return;
        }
        callback();
    }

    trainCenterIdValidator = (rule, value, callback) => {
        if (!value) {
            callback('请选择培训中心');
        }
        callback();
    }

    bizIdValidator = (rule, value, callback) => {

        let bizType = this.props.form.getFieldValue("bizType")
        if (bizType && !value) {
            callback('选择实体类型后请选择实体');
        }
        callback();
    }
    /**
     * 表单基础内容
     */
    _base() {
        const { data, form } = this.props;
        let { getFieldDecorator } = form;
        let bizId = form.getFieldValue("bizId") || data.bizId || 0
        let { bizType, bizChange, date } = this.state;
        let initRows = []
        if (!bizChange) {
            if (data.bizId && data.bizType === this.state.bizType) {
                if (this.state.bizType == 0) {
                    initRows = [{ id: data.bizId, name: data.bizName }]
                }
                if (this.state.bizType == 1) {
                    initRows = [{ id: data.bizId, title: data.bizName }]
                }
                if (this.state.bizType == 21) {
                  initRows = [{ id: data.bizId, name: data.bizName }]
                }
                if (this.state.bizType == 24) {
                    initRows = [{ id: data.bizId, title: data.bizName }]
                }
                if (this.state.bizType == 32) {
                    initRows = [{ id: data.bizId, name: data.bizName }]
                }
                if (this.state.bizType == 36) {
                  initRows = [{ id: data.bizId, name: data.bizName }]
                }
                if (this.state.bizType == 8) {
                    initRows = [{ id: data.bizId, name: data.bizName }]
                }
                if (this.state.bizType == 16) {
                    initRows = [{ id: data.bizId, name: data.bizName }]
                }
            }
        }
        return [


            <Item label="行为" >
                {getFieldDecorator('actionType', {
                    initialValue: data.actionType,
                    rules: [{ required: true, message: '请选择行为' }],
                })(

                    <WizSelect
                        placeholder="请选择行为"
                        onChange={(actionType) => { this.setState({ actionType }) }}
                    >
                        {actionOption}
                    </WizSelect>,
                    <Cascader
                        fieldNames={{ label: 'name', value: 'code', children: 'items' }}
                        options={options}
                        onChange={(actionType) => { this.setState({ actionType }) }}
                    ></Cascader>
                )}
            </Item>,
            <Item label="业务类型" >
                {getFieldDecorator('bizType', {
                    initialValue: this.state.bizType,
                })(
                    <WizSelect
                        placeholder="请选择业务类型"
                        allowClear={true}
                        value={bizType}
                        onChange={(bizType) => {
                            if (bizType || bizType == 0) {
                            } else {
                                form.setFieldsValue({ bizId: null })
                            }

                            this.setState({ bizType: bizType, bizChange: true })
                        }}
                    >
                        <Option value={0}>课程</Option>
                        <Option value={1}>考试</Option>
                        <Option value={2}>问卷</Option>
                        <Option value={24}>帖子</Option>
                        <Option value={32}>路径阶段</Option>
                        <Option value={8}>线下课程</Option>
                        <Option value={16}>路径评语</Option>
                        <Option value={21}>证书</Option>
                        <Option value={36}>班级</Option>
                        {/* <Option value={2}>直播</Option>
                        <Option value={3}>公告</Option>
                        <Option value={4}>话题</Option>
                        <Option value={5}>活动</Option>
                        <Option value={6}>投票</Option>
                        <Option value={24}>帖子</Option> */}
                    </WizSelect>,
                )}
            </Item>,
            <Item label="业务实体" >
                {getFieldDecorator('bizId', {
                    // rules: [{ validator: this.bizIdValidator }],
                    initialValue: data.bizId,
                })(
                    <WizTableForm
                        key={this.state.bizType + '@' + date}
                        {..._tableFormProps(this.state.bizType)}
                        selectType={'radio'}
                        initRows={initRows}
                    />
                )}
            </Item>,

            <Item label="名称" >
                {getFieldDecorator('ruleName', {
                    rules: [{ required: true, message: "请输入名称" }],
                    initialValue: data.ruleName,
                })(<WizInput maxLength={30} placeholder='请输入名称,最多30字' />)}
            </Item>,
            <Item label="适用范围" >
                {getFieldDecorator('authCmd', {
                    // rules: [{ required: true, validator: this.validateEndDate }],
                    rules: [{ required: true, validator: authValidator }],
                    initialValue: data.authCmd,
                })(
                    <WizAuthority key={this.props.manageKey} value={data.authCmd} keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']} />
                )}
            </Item>,

            <Item label="产物类型">
                {getFieldDecorator('outputClass', {
                    rules: [{ required: true, validator: outputClassValidator }],

                    initialValue: data.outputClass ? data.outputClass.split(',').map(i => parseInt(i)) : [],

                })(
                    <WizCheckbox.Group>
                        <WizCheckbox value={0}>积分</WizCheckbox>
                        <WizCheckbox value={1}>学分</WizCheckbox>
                        <WizCheckbox value={2}>证书</WizCheckbox>
                        <WizCheckbox value={3}>经验</WizCheckbox>
                        <WizCheckbox value={4}>阶段</WizCheckbox>
                    </WizCheckbox.Group>,
                )}
            </Item>,

            <Item label="状态">
                {getFieldDecorator('state', {
                    initialValue: data.state || 0
                })(
                    <WizRadio.Group>
                        <WizRadio value={1}>有效</WizRadio>
                        <WizRadio value={0}>无效</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>,

        ]
    }
    handleReset = () => {
        //重置表单
        this.setState({
            output0: null,
            output1: null,
            output2: null,
            output3: null,
            propsInit: false,
            bizChange: false,
            bizType:undefined,
            date: new Date().getTime()
        })
        this.props.form.resetFields();
    };
    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" htmlType="submit">
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
     * 拓展属性
     */
    _ext = (type = []) => {
        let r = [<></>]
        if (type.length > 0) {
            if (type.findIndex(par => par === 0) != -1) {
                r.push(this._dividerName('积分产物设置'))
                r.push(this._outPutType('id', '0'))
                r.push(this._extOpther(false, '0'))
            }
            if (type.findIndex(par => par === 1) != -1) {
                r.push(this._dividerName('学分产物设置'))
                r.push(this._outPutType('id', '1'))
                r.push(this._extOpther(true, '1'))
            }
            if (type.findIndex(par => par === 2) != -1) {
                r.push(this._dividerName('证书产物设置'))
                r.push(this._outPutType('text', '2'))
                r.push(this._extOpther(false, '2'))
            }
            if (type.findIndex(par => par === 3) != -1) {
                r.push(this._dividerName('经验产物设置'))
                r.push(this._outPutType('id', '3'))
                r.push(this._extOpther(false, '3'))
            }
            if (type.findIndex(par => par === 4) != -1) {
                r.push(this._dividerName('阶段产物设置'))
                r.push(this._outPutType('stage', '4'))
                r.push(this._extOpther(false, '4'))
            }
        }
        return r;

    }
    _dividerName = (dividerName) => {
        return [
            <Item wrapperCol={{ span: 18, offset: 3 }}>
                <WizDivider>
                    {dividerName}
                </WizDivider>
            </Item>,
        ]
    }
    _outPutType = (outPutType, key) => {

        let onChangeRowMap = (dataMap, rowKey = key) => {
            if (dataMap != null) {
                this.setState({
                    [`output${rowKey}`]: Object.values(dataMap).map(val => { return { id: val.id, name: val.title || val.name } })
                })
            }
        }
        let { getFieldDecorator } = this.props.form;
        let { data } = this.props;
        if (outPutType === 'text') {
            return [
                <Item label="产物" wrapperCol={{ span: 14, offset: 0 }}>
                    {getFieldDecorator('outputValue' + key, {
                        rules: [{ required: true, validator: formValidator }],
                        initialValue:this.props.form.getFieldValue('outputValue' + key) || data[`outputValue${key}`],
                    })(
                        <WizTableForm
                            key={'outputFlag@' + key}
                            {...WizTableForm.Config.cert()}
                            selectType={'radio'}
                            initRows={this.state[`output${key}`] || (data[`outputValue${key}`] ? [{ id: data[`outputValue${key}`], name: data[`outputName${key}`] }] : [])}
                            onChangeRowMap={onChangeRowMap}
                        />
                    )}
                </Item>,
            ]
        } else if (outPutType === 'stage') {
            return [
                <Item label="产物" wrapperCol={{ span: 14, offset: 0 }}>
                    {getFieldDecorator('outputValue' + key, {
                        rules: [{ required: true, validator: formValidator }],
                        initialValue:this.props.form.getFieldValue('outputValue' + key) || data[`outputValue${key}`],
                    })(
                        <WizTableForm
                            key={'outputFlag@' + key}
                            {...WizTableForm.Config.pathStage()}
                            selectType={'radio'}
                            initRows={this.state[`output${key}`] || (data[`outputValue${key}`] ? [{ id: data[`outputValue${key}`], name: data[`outputName${key}`] }] : [])}
                            onChangeRowMap={onChangeRowMap}
                        />
                    )}
                </Item>,
            ]
        }else{

            return [
                <Item label="产物" wrapperCol={{ span: 14, offset: 0 }}>
                    {getFieldDecorator('outputValue' + key, {
                        rules: [{ required: true, validator: numberValidator }],
                        initialValue: data[`outputValue${key}`],
                    })(
                        <WizInputNumber
                            style={{ 'width': '100%' }}
                            onChange={this.limitNum}
                            placeholder='' />
                    )}
                </Item>,
            ]
        }
    }

    /**
     * 设置
     */
    _extOpther = (haveFlag, key) => {
        let { getFieldDecorator } = this.props.form;
        let { data } = this.props;
        let onChangeRowMap = (dataMap, rowKey = key) => {
            if (dataMap != null) {
                this.setState({
                    [`output${rowKey}`]: Object.values(dataMap).map(val => { return { id: val.id, name: val.title || val.name } })
                })
            }
        }
        let limitType
        let limitCountInitValue
        if (this.props.form.getFieldValue('limitType' + key) == 0 || this.props.form.getFieldValue('limitType' + key)) {
            limitType = this.props.form.getFieldValue('limitType' + key)
        } else {
            limitType = data['limitType' + key]
        }
        if (limitType == 3) {
            limitCountInitValue = { limitCycleType: data['limitCycleType' + key] || 0, limitNum: data['limitCount' + key] || 0 }
        } else {
            limitCountInitValue = { limitCycleType: data['limitCycleType' + key], limitNum: data['limitCount' + key] || 0 }
        }
        let result = [<></>]

        if (haveFlag) {
            result.push(
                <Item label="产物标识" >
                    {getFieldDecorator('outputFlag' + key, {
                        rules: [{ required: true, validator: formValidator }],
                        initialValue: this.props.form.getFieldValue('outputFlag' + key) || data[`outputFlag${key}`] || null,
                    })(
                        <WizTableForm
                            key={'outputFlag@' + data[`outputFlag${key}`]}
                            {...WizTableForm.Config.subject()}
                            selectType={'radio'}
                            initRows={this.state[`output${key}`] || (data[`outputFlag${key}`] ? [{ id: data[`outputFlag${key}`], name: data[`outputFlagName${key}`] }] : [])}
                            onChangeRowMap={onChangeRowMap}
                        />
                    )}
                </Item>)
        }
        result.push(
            <Item label="限制类型">
                {getFieldDecorator('limitType' + key, {
                    rules: [{ required: true, message: "请输入限制类型" }],
                    initialValue: data['limitType' + key] || 0
                })(
                    <WizRadio.Group>
                        <WizRadio value={0}>单次</WizRadio>
                        <WizRadio value={1}>多次</WizRadio>
                        <WizRadio value={2}>无限制</WizRadio>
                        <WizRadio value={3}>周期限制</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>)
        if (limitType === 1 || limitType === 3) {
            result.push(
                <Item label="限制次数">
                    {getFieldDecorator('limitCount' + key, {
                        rules: [{ required: true, message: "请输入次数" }],
                        initialValue: limitCountInitValue || {}
                    })(
                        <LimitCount key={key} limitType={limitType}>

                        </LimitCount>
                    )}
                </Item>,
            )
        }
        return result
    }

    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        let { submit } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                submit && submit(values)
            }
        });
    };

    render() {

        let { data } = this.props;
        let outputClass = this.props.form.getFieldValue("outputClass")
        let extOptions = [];
        if (outputClass && outputClass instanceof Array && outputClass.length > 0) {
            outputClass.map(p => extOptions.push(p))
        }
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizForm
                {...formItemLayout}
                onSubmit={this.handleSubmit}
            >
                {this._base()}
                {this._ext(outputClass)}
                {this._submit()}
            </WizForm>
        )

    }
}

export default WizForm.create()(RuleForm);

/**
 * 默认值
 */
RuleForm.defaultProps = {
    // title: '新增题目',
    data: {},
    selects: []
}

/**
 * props入参校验
 */
RuleForm.propTypes = {
}

